import React from 'react';
import { AssetUrls } from 'config/assets';

interface Props {
  /** Rendered width and height in px. Mocks use 12 to 17 inline, 22 in rows, 44 in headers. */
  size: number;
  className?: string;
}

/**
 * The official TopDecked icon mark, rendered as supplied (no recolor, crop, or trace).
 * The file is a full-bleed purple square, so the mocks' rounded-tile treatment is
 * applied here: 10px at 44px and proportionally smaller below, so it reads as an icon
 * tile on a dark panel rather than a hard square. This component is the only consumer
 * of AssetUrls.partners.topdeckedMark.
 */
export const TopDeckedMark: React.FC<Props> = ({ size, className }) => {
  const radius = size >= 40 ? 10 : Math.max(3, Math.round(size * 0.22));
  return (
    <img
      className={className}
      src={AssetUrls.partners.topdeckedMark}
      alt="TopDecked"
      width={size}
      height={size}
      style={{ width: size, height: size, borderRadius: radius, flexShrink: 0, display: 'inline-block' }}
      decoding="async"
    />
  );
};

export default TopDeckedMark;
